import type z from 'zod/v4'
import { index, integer, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

export const Competency = pgTable(
  'competency',
  {
    id: uuid().notNull().primaryKey(),
    name: text().notNull(),
    description: text(),
    order: integer().notNull(),
    legacyCategoryId: integer(),
    legacyNeonTagId: uuid(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true, precision: 3 }).notNull(),
  },
  (columns) => [
    index('competency_name_idx').on(columns.name),
    index('competency_updated_at_idx').on(columns.updatedAt),
    index('competency_created_at_idx').on(columns.createdAt),
  ],
)

export const InsertCompetencySchema = createInsertSchema(Competency)
export const UpdateCompetencySchema = createUpdateSchema(Competency)
  .omit({ id: true, legacyCategoryId: true, legacyNeonTagId: true })
  .partial()
export const SelectCompetencySchema = createSelectSchema(Competency)

export type InsertCompetency = typeof Competency.$inferInsert
export type UpdateCompetency = z.infer<typeof UpdateCompetencySchema>
export type SelectCompetency = typeof Competency.$inferSelect
